import React from 'react';
import Style from './Home.module.css';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Avatar, Wrap, WrapItem } from '@chakra-ui/react';
import mypicture from '../../../assets/images/mypicture.jpeg';

function HomePage() {
  return (
    <div className={Style.body}>
      <Row>
        <Col sm={7}>
          <div className={Style.title}>
            <div>Hi,</div>
            <div>
              I'm <span className={Style.fontshadow}>D</span>ayo,
            </div>
            <div>Frontend developer</div>
          </div>
          <div className={Style.subtext}>
            Web | Mobile | UI & Prototyping | Testing
          </div>
          <Link to={'/contact'} className={Style.navlink}>
            <Button className={Style.contactbutton}>Contact me !</Button>
          </Link>
        </Col>
        <Col>
          <div className={Style.pagetop}>
            <div>
              <Wrap>
                <WrapItem>
                  <Avatar
                    className={Style.avatar}
                    name='Dan Abrahmov'
                    src={mypicture}
                  />
                </WrapItem>
              </Wrap>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default HomePage;
